import styled from 'styled-components';
import { useGetStaticItemSum } from '../../../interface/item';
import { useEffect, useState } from 'react';
import theme from '../../../styles/theme';
import { NumericFormatCustom } from './common';
import CommonDataGrid from '../../common/CommonDataGrid';
import { ResponsiveBar } from '@nivo/bar';
import { MyResponsiveBar } from '../../SampleChart';
import { useGetInoutStatic } from '../../../interface/inout';
import {IOT_TP} from '../../common/constants';
import ChartStaticItem from './ChartStaticItem';
import ChartStaticInoutItem from './ChartStaticInoutItem';
import { useGetStaticInspect } from '../../../interface/inspect';
import moment from 'moment';
import ChartStaticInspect from './ChartStaticInspect';
import ChartStaticItemStatus from './ChartStaticItemStatus';
import { useNavigate } from 'react-router-dom';

const MainWrap =  styled.div`
    margin: auto;
    padding:0;
    width: calc(100% - 2rem);
    min-width: calc(340px + 2rem);
    h3 {
        margin:0;
        font-size: 1.2rem;
    }
    .titleLine {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        > span {
            font-size: 0.8rem;
            cursor: pointer;
        }
    }
`;

const GridOne = styled.div`
    width: 100%;
    background: ${theme.color.primary.main};
    border-radius: 8px;
    border: 0.5px solid ${theme.color.black[10]};
    padding: 1rem;
    &:hover {
        // background: ${theme.color.primary.pupple};
        box-shadow: ${theme.color.shadow};
    }
    transition: all 400ms ease-in-out, transform 400ms ease-in-out;
`;

const GridTwo = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, calc(50% - 0.5rem)));
    gap: 1rem;
    > div {
        width: 100%;
        background: ${theme.color.primary.main};
        border-radius: 8px;
        border: 0.5px solid ${theme.color.black[10]};
        padding: 1rem;
        &:hover {
            // background: ${theme.color.primary.pupple};
            box-shadow: ${theme.color.shadow};
        }
        transition: all 400ms ease-in-out, transform 400ms ease-in-out;
    }
`;

const staticItemColumn = [
    { field: 'pcat_nm', headerName: '구분', width:100},
    { field: 'chart', headerName: '현황', width:250, renderCell:ChartStaticItem },
    { field: 'tot_cnt', headerName: '전체', width:90, renderCell:NumericFormatCustom },
    { field: 'vtot_cnt', headerName: '유효', width:90, renderCell:NumericFormatCustom },
    { field: 'n_cnt', headerName: '정상', width:90, renderCell:NumericFormatCustom },
    { field: 'b_cnt', headerName: '고장/파손', width:90, renderCell:NumericFormatCustom },
    { field: 'p_cnt', headerName: '수리', width:90, renderCell:NumericFormatCustom },
    { field: 'r_cnt', headerName: '임대', width:90, renderCell:NumericFormatCustom },
    { field: 'x_cnt', headerName: '분실', width:90, renderCell:NumericFormatCustom },
    { field: 's_cnt', headerName: '판매', width:90, renderCell:NumericFormatCustom },
    { field: 't_cnt', headerName: '폐기', width:90, renderCell:NumericFormatCustom },
    { field: 'w_cnt', headerName: '소멸', width:90, renderCell:NumericFormatCustom },
    { field: 'z_cnt', headerName: '기타', width:90, renderCell:NumericFormatCustom },
]

const staticInoutColumn = [
    { field: 'iot_nm', headerName: '조사명', width:250},
    { field: 'is_ing', headerName: '조사상태', width:80, headerAlign:'center', align:'center'},
    { field: 'cnt_out', headerName: '반출', width:80, headerAlign:'center', align:'center'},
    { field: 'cnt_in', headerName: '반입', width:80, headerAlign:'center', align:'center'},
    { field: 'chart', headerName: '반입현황', flex:20, minWidth:250, renderCell: ChartStaticInoutItem},
]

const staticInspectColumn = [
    { field: 'isp_nm', headerName: '조사명', width:250},
    { field: 'isp_kdnm', headerName: '조사대상', width:120, headerAlign:'center', align:'center'},
    { field: 'isp_stnm', headerName: '조사상태', width:80, headerAlign:'center', align:'center'},
    { field: 'sdate', headerName: '조사기간(시작)', width:120, headerAlign:'center', align:'right'},
    { field: 'edate', headerName: '조사기간(종료)', width:120,headerAlign:'center', align:'right'},
    // { field: 'item_tot_cnt', headerName: '대상 개수', width:80, renderCell:NumericFormatCustom },
    // { field: 'isp_tot_cnt', headerName: '조사 개수', width:80, renderCell:NumericFormatCustom },
    { field: 'chart', headerName: '진행율', flex:20, minWidth:250, renderCell: ChartStaticInspect},
]

const Main = () => {

    const navigate = useNavigate();
    // const {data: staticItemSum, isLoading: staticItemSumLoading} = useGetStaticItemSum();
    const {data: staticInout, isLoading: staticInoutLoading} = useGetInoutStatic({iot_tp:IOT_TP.SEARCH});
    const {data: staticInspect, isLoading: staticInspectLoading} = useGetStaticInspect();


    const [totItem, setTotItem] = useState([]);
    const [pCate , setPCate] = useState([]);

    const [staticInoutList , setStaticInoutList] = useState([]);
    const [staticInspetList , setStaticInspectList] = useState([]);

    useEffect(()=>{
        if(staticInout){
            setStaticInoutList(staticInout.map((item,index)=>({...item,is_ing:item.is_ing===1?'진행중':'완료',chart:[item],id:index})))
        }
    },[staticInout])

    useEffect(()=>{
        if(staticInspect){
            setStaticInspectList(staticInspect.map((item,index)=>({
                                                                    ...item,
                                                                    sdate: item.sdate ? moment(item.sdate).format('YYYY/MM/DD') : '',
                                                                    edate: item.edate ? moment(item.edate).format('YYYY/MM/DD') : '',
                                                                    chart:[{complete:item.isp_tot_cnt>0 ? Math.ceil(item.isp_cnt/item.isp_tot_cnt*100):0}],
                                                                    id:index
                                                                })))
        }
    },[staticInspect])

    return (
        <MainWrap>
            <GridTwo style={{gridTemplateColumns:'34rem auto'}}>
                <div>
                    <div className='titleLine'><h3>자산현황</h3><span onClick={()=>navigate('/admin/static/item')}>전체보기 &gt;</span></div>
                    <div style={{width:'100%',height:'16rem'}}>
                    <ChartStaticItem />
                    </div>
                </div>
                <div>
                <div className='titleLine'><h3>조사장비</h3><span onClick={()=>navigate('/admin/static/searchItem')}>전체보기 &gt;</span></div>
                    <div style={{width:'100%',height:'16rem'}}>
                        <ChartStaticItemStatus />
                    </div>
                </div>
            </GridTwo>
            <div style={{height:'0.5rem'}} />
            <GridOne onClick={()=>navigate('/admin/static/inout')}>
                <div className='titleLine'><h3>조사설치 현황</h3><span onClick={()=>navigate('/admin/static/inout')}>전체보기 &gt;</span></div>
                <div style={{height:'16rem'}}>
                <CommonDataGrid
                    isLoading={staticInoutLoading}
                    list={staticInoutList}
                    columns={staticInoutColumn}
                    showCount={6}
                />
                </div>
            </GridOne>
            <div style={{height:'0.5rem'}} />
            <GridOne onClick={()=>navigate('/admin/static/inspect')}>
                <div className='titleLine'><h3>자산조사 현황</h3><span onClick={()=>navigate('/admin/static/inspect')}>전체보기 &gt;</span></div>
                <div style={{height:'10rem'}}>
                <CommonDataGrid
                    isLoading={staticInspectLoading}
                    list={staticInspetList}
                    columns={staticInspectColumn}
                    showCount={3}
                />
                </div>
            </GridOne>
        </MainWrap>
    )

}

export default Main;